/*
 * The Frosted Muzzle — cart drawer analytics (Phase 3 / Global Chrome).
 *
 * Fires `view_cart` when the drawer opens and `remove_from_cart` when a line
 * is removed, per docs/cross-cutting/analytics.md. Events are dispatched as
 * `fm:analytics` CustomEvents on `document` — sections never call analytics
 * APIs directly. Subscribes to Dawn's existing pub/sub bus (cart-update);
 * it does NOT modify pubsub.js / cart.js / global.js.
 */
(function () {
  function emit(event, payload) {
    document.dispatchEvent(new CustomEvent('fm:analytics', { detail: { event: event, payload: payload } }));
  }

  function readCartSummary() {
    const drawer = document.querySelector('cart-drawer');
    const totalEl = drawer ? drawer.querySelector('.totals__total-value') : null;
    const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    const systemLines = drawer ? drawer.querySelectorAll('[data-system-line], .cart-item--system').length : 0;
    return {
      total_value: totalEl ? totalEl.textContent.trim() : null,
      item_count: bubble ? parseInt(bubble.textContent.trim(), 10) || 0 : 0,
      system_count: systemLines,
    };
  }

  function watchDrawerOpen() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    let wasActive = drawer.classList.contains('active');
    const observer = new MutationObserver(() => {
      const isActive = drawer.classList.contains('active');
      if (isActive && !wasActive) {
        emit('view_cart', readCartSummary());
      }
      wasActive = isActive;
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function watchRemovals() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('cart-drawer .cart-remove-button[data-variant-id]');
      if (!button) return;
      const row = button.closest('.cart-item');
      const qtyInput = row ? row.querySelector('.quantity__input') : null;
      emit('remove_from_cart', {
        variant_id: button.dataset.variantId,
        quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
      });
    });
  }

  function init() {
    watchDrawerOpen();
    watchRemovals();

    // Keep the drawer in sync with cart mutations published elsewhere.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.classList.contains('active')) {
          emit('view_cart', readCartSummary());
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
